module.exports = __webpack_public_path__ + "img/step_3-6.e5c69be1.png";